// initial state
const state = {
	isVisible: true
};

// actions
const actions = {};

// mutations
const mutations = {
	SHOW_MENU(state) {
		state.isVisible = true;
	},
	HIDE_MENU(state) {
		state.isVisible = false;
	}
};
export default {
	state,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./app/store/modules/menu.js